import { gsap, TimelineMax } from 'gsap';
import Tools from './../components/tools';
import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ScrollMagic from 'scrollmagic';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

export default class Page {
    constructor() {
        gsap.registerPlugin(ScrollTrigger);
        ScrollMagicPluginGsap(ScrollMagic, gsap);

        this.navigation();
        this.pageHeader();
        this.tabs();
        this.background();
        this.avis();

        this.tools = new Tools();
    }

    navigation() {
        const aside = document.querySelector('aside');

        if (aside) {
            window.addEventListener('scroll', () => {
                if (window.pageYOffset > window.innerHeight - 1) {
                    aside.classList.add('visible');
                } else {
                    aside.classList.remove('visible');
                }
            });
        }
    }

    pageHeader() {
        this.figures = document.querySelectorAll('header .row .slider-wrapper figure');
        const slider = document.querySelector('header .row .slider-wrapper');

        if (slider) {
            const slideWidth = document.querySelector('header .row .slider-wrapper').offsetWidth,
                nbSlides = this.figures.length,
                elt = 0,
                cpt = 0;

            // Animation scroll horizontal
            let controller = new ScrollMagic.Controller(),
                tl = gsap.timeline({ paused: true });

            tl.to(
                'header .row .slider-wrapper',
                {
                    x: `-${100 * (nbSlides - 1)}%`,
                    ease: 'none',
                    onComplete: () => {
                        window.scrollTo({
                            top: this.tools.offset(document.querySelector('section')).top,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                }
            );

            new ScrollMagic.Scene({
                triggerElement: 'header',
                triggerHook: 'onLeave',
                duration: slideWidth * nbSlides
            })
                .setPin('header .row .slider-wrapper')
                .setTween(tl)
                .addTo(controller);
        }
    }

    animationFigure(cpt, ratio, nbSlides) {
        if (ratio * nbSlides - (cpt - 1) < 1) {
            // Element précédent
            // console.log(cpt + .5 - ratio * nbSlides);
            this.figures[cpt - 1].children[0].style.transform = `scale(${cpt + .5 - ratio * nbSlides})`;
            this.figures[cpt - 1].children[0].style.opacity = cpt + .5 - ratio * nbSlides;
            // Elément suivant
            this.figures[cpt].children[0].style.transform = `scale(${ratio * nbSlides - cpt + 1})`;
            this.figures[cpt].children[0].style.opacity = ratio * nbSlides - cpt + 1;
        }
    }

    tabs() {
        const tabs = document.querySelectorAll('aside ul li');

        Array.from(tabs).forEach(tab => {
            tab.addEventListener('click', () => {
                window.scrollTo({
                    top: this.tools.offset(document.querySelector(`section article[data-id='${tab.dataset.target}']`)).top,
                    left: 0,
                    behavior: 'smooth'
                });
            });
        });
    }

    background() {
        const elts = document.querySelectorAll('.article .container__background');
        if (elts.length > 0) {
            elts.forEach((elt) => {
                const wrapper = elt.querySelector('.container__wrapper');
                if (wrapper.children[1]) {
                    gsap.to(
                        wrapper.children[1],
                        {
                            scrollTrigger: {
                                trigger: wrapper,
                                start: 'top 80%',
                            },
                            ease: 'none',
                            x: (wrapper.children[1].clientWidth + wrapper.offsetWidth) * -1,
                            duration: 25,
                        }
                    );
                }
            });
        }
    }

    avis() {
        const sliders = document.querySelectorAll('.sb-feed-posts');
        if (sliders.length > 0) {
            sliders.forEach((slider) => {
                tns({
                    container: slider,
                    items: 1,
                    slideBy: 'page',
                    autoplay: false,
                    loop: true,
                    controls: false,
                    nav: true,
                    navPosition: 'top',
                    speed: 650,
                    autoHeight: true,
                });
            });
        }
    }
}